import styled from 'styled-components';
import { isPortrait, widthEm } from '../../utils/size';

export const Header = styled.h1`
    font-family: Averta;
    font-size: 28px;
    font-weight: 300;
    margin: 20px 0 10px;

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

export const Title = styled.h2`
    font-family: Averta;
    margin: 0 0 5px 0;
    font-weight: 300;
    font-size: 28px;
    word-wrap: break-word;
    width: 100%;
`;

export const Description = styled.p`
    object-fit: contain;
    font-family: Lato;
    line-height: 1.33;
    color: #000;
    margin-bottom: 0.75em;
    word-break: break-word;
    font-size: ${() => (isPortrait() ? 16 : 15)}px;
    overflow: hidden;
    margin-top: 4px;

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

export const MultiActionsCardActionWrapper = styled.div`
    padding: 5px 20px 15px 20px;
    height: ${props =>
        props.isMultiDonation ? (isPortrait() ? 320 : 210) : isPortrait() ? 415 : 265}px;
    position: relative;
    margin: ${props => (props.numActions === 2 && !isPortrait() ? `0 6px` : ``)};
    flex: 1;
    border-right: 1px solid #f1f1ee;

    ${props =>
        (props.isMultiDonation && props.numActions > 2) ||
        (isPortrait() && props.isMultiDonation && props.numActions >= 2)
            ? `cursor: pointer`
            : ``};

    ${props =>
        (widthEm() < 30 || props.isMultiDonation) &&
        `
            display: flex;
            flex: 1;
            box-shadow: 0 2px 4px 0 #e4e4e4;
            border-radius: ${props.isMultiDonation ? `4px` : `0`};
            border: solid 1px #dadad9;
            padding: ${
                props.isMultiDonation && isPortrait()
                    ? `20px 15px 15px`
                    : `16px 11px 12px`
            };`};

    &:focus {
        outline: none;
    }

    &:last-child {
        ${props => (widthEm() > 30 || props.isMultiDonation ? `border-right: 0;` : ``)};
    }

    h2 {
        font-size: 24px;
        line-height: 110%;

        @media (max-width: 32em) {
            font-size: 20px;
        }

        @media (max-width: 30.0625em) {
            font-size: 24px;
        }
    }

    button {
        width: calc(100% - 40px);
        margin: 0;
        position: absolute;
        left: 20px;
        bottom: 0;
        word-break: break-word;
        span {
            font-size: ${() => (isPortrait() ? 24 : 18)}px;
        }

        &:active {
            background-color: #ff245e;
            border: solid 1px #ff245e;
            color: #fff;
            span {
                color: #fff;
            }
        }

        ${() =>
            !isPortrait() &&
            `
                &:hover {
                    background-color: #ff245e;
                    border: solid 1px #ff245e;
                    color: #fff;
                    span {
                        color: #fff;
                    }
                }`};

        ${props =>
            (widthEm() < 30 || props.isMultiDonation) &&
            `
                left: 10px;
                bottom: 12px;
                padding: 0;
                width: calc(100% - 20px);
            `};
    }
`;

export const ActionContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    &.hide {
        display: none;
    }
`;

export const ActionSuccess = styled.div`
    &.hide {
        display: none;
    }
`;

export const PartnerImage = styled.img`
    width: auto !important;
    max-height: ${() => (widthEm() < 30 ? 45 : 35)}px;
`;
